import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import './styles/CreateStudentPage.css'; 
import { useNavigate } from 'react-router-dom'; 

function PublicStudentFormPage({ isSidebarCollapsed }) {

  const [branchList, setBranchList] = useState([]);
  const [errors, setErrors] = useState({}); 
  const navigate = useNavigate(); 

  useEffect(() => {
    
    api.get('/utils/getBranchList')
      .then(response => setBranchList(response.data.data.branchList))
      .catch(error => console.error('Error fetching branch list:', error));
  }, []);

  const validateForm = (formData) => {
    const errors = {};

    
    if (!formData.student_name) errors.student_name = 'Student name is required';
    if (!formData.birth_date) errors.birth_date = 'Birth date is required';
    if (formData.branch_id === "") errors.branch_id = 'Branch is required';
    if (!formData.address) errors.address = 'Address is required';
    if (!formData.contact_person_name) errors.contact_person_name = 'Contact person name is required';
    if (!formData.relationship) errors.relationship = 'Relationship is required';
    if (!formData.phone_number) errors.phone_number = 'Phone number is required';

    return errors;
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      student_name: e.target.student_name.value,
      birth_date: e.target.birth_date.value,
      branch_id: e.target.branch_id.value,
      address: e.target.address.value,
      contact_person_name: e.target.contact_person_name.value,
      relationship: e.target.relationship.value,
      phone_number: e.target.phone_number.value
    };

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      console.log('Validation Errors:', validationErrors);
    } else {
      const confirmation = window.confirm('Are you sure you want to proceed with this action?');
      if (!confirmation) {
        return;
      }

      const requestBody = {
        data: {
          studentData: {
            student_name: formData.student_name,
            birth_date: formData.birth_date,
            branch_id: formData.branch_id,
            address: formData.address,
            contact_person_name: formData.contact_person_name,
            relationship: formData.relationship,
            phone_number: formData.phone_number
          }
        }
      };
      console.log(requestBody);
      api.post('/student/public/save', requestBody)
        .then(response => {
          console.log('Student added successfully:', response.data);
          navigate('/success', { state: { message: 'Data berhasil diinput!' } });
        })
        .catch(error => {
          console.error('Error adding student:', error);
          navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    }
  };

  return (
    <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
      <div className="page-title">Register New Public Student</div>
      <div className="form-container">
        <form onSubmit={handleSubmit}>
          <div className="section">
            <h3 className="section-header">Student Data</h3>
              <label>Student Name</label>
              <input type="text" name="student_name" />
              {errors.student_name && <div className="error-message">{errors.student_name}</div>}

              <label>Birth Date</label>
              <input type="date" name="birth_date" />
              {errors.birth_date && <div className="error-message">{errors.birth_date}</div>}

              <label>Branch</label>
              <select name="branch_id">
                <option key="" value="">Select Branch</option>
                {branchList.map(branch => (
                  <option key={branch.branch_id} value={branch.branch_id}>{branch.branch_name}</option>
                ))}
              </select>
              {errors.branch_id && <div className="error-message">{errors.branch_id}</div>}

              <label>Address</label>
              <textarea name="address"></textarea>
              {errors.address && <div className="error-message">{errors.address}</div>}
              
              <label>Contact Person Name</label>
              <input type="text" name="contact_person_name" />
              {errors.relationship && <div className="error-message">{errors.relationship}</div>}

              <label>Relationship</label>
              <input type="text" name="relationship" />
              {errors.relationship && <div className="error-message">{errors.relationship}</div>}

              <label>Phone Number</label>
              <input type="text" name="phone_number" />
              {errors.phone_number && <div className="error-message">{errors.phone_number}</div>}
          </div>
          <div className="search-container">
            <button type="submit">Submit</button>  
          </div>
        </form>
      </div>
    </div>
  );
}

export default PublicStudentFormPage;
